import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import aboutMe from "../../../images/aboutMe.jpg";

const AboutMe = () => {
  const title = {
    fontFamily: "'Satisfy', cursive",
    color: "#033d44",
  };
  return (
    <Container id="about-me">
      <h1 className="display-1 fw-bold ps-2 text-center mb-5" style={title}>
        About Me
      </h1>
      <Row>
        <Col
          xs={12}
          md={6}
          className="d-flex flex-column align-items-center justify-content-center"
        >
          <img src={aboutMe} className="img-fluid border rounded-3" alt="" />
        </Col>
        <Col xs={12} md={6} className="mt-3 w-xs-100 w-md-50 px-3">
          <p style={{ textAlign: "justify" }}>
            I'm a final year undergraduate student pursuing my bachelor's in
            computer science and engineering from a public university in
            Bangladesh.
          </p>
          <p style={{ textAlign: "justify" }}>
            I have started my MERN full-stack web development journey earlier
            2021 and fell in love with that. After discovering my passion for
            React Web Development, I continued my journey and alongside a
            developed a few pet projects that I have built with web technologies
            such as HTML5, CSS3, JavaScript. I have worked with framework like
            Material-UI, Bootstrap 5, Express.js and library like React.
          </p>
          <p style={{ textAlign: "justify" }}>
            {" "}
            I am an efficient learner and determined to do better today than I
            did yesterday. I also have knack for illustration and my favorite
            therapy is reading book.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default AboutMe;
